import { makeStyles, MenuGroup, MenuGroupHeader } from "@fluentui/react-components";
import INavigationSection from "../../../models/navigation/INavigationSection";
import INavigationLink from "../../../models/navigation/INavigationLink";
import MenuItemLink from "./MenuItemLink";
import { dolphinTokens } from "../../../utils/Theme";
import INavigationArea from "../../../models/navigation/INavigationArea";

const useStyles = makeStyles({
    group: {
        padding: "10px 15px",
    },
    header: {
        color: dolphinTokens.colorLightBlue,
        fontSize: "0.75rem",
        fontWeight: 600,
        textTransform: "uppercase",
        marginTop: "0.5em",
    }
});

interface IDesktopSectionProps {
    area: INavigationArea;
    section: INavigationSection;
}

export default function DesktopSection(props: IDesktopSectionProps) {
    const { area, section } = props;
    const styles = useStyles();

    return (
        <MenuGroup key={section.id} className={styles.group}>
            <MenuGroupHeader className={styles.header}>
                {section.name}
            </MenuGroupHeader>
            {
                section.links.map((link: INavigationLink, index: number) => (
                    <MenuItemLink key={index} to={`/${area.slug}/${link.path}`} label={link.title} />
                ))
            }
        </MenuGroup>
    );
}